import './styles.scss';

import React from 'react';
import ReactDOM from 'react-dom';

import { version } from '../package.json';
import config from './autoload.config';
import SmartMaps from './smart-maps/main';
// import reportWebVitals from './reportWebVitals';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  // eslint-disable-next-line
  <SmartMaps config={config} version={version} />,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line
// reportWebVitals(console.log);
